// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetPreview_container__dbUfE","frame":"WidgetPreview_frame__2566h","powered":"WidgetPreview_powered__385vd","powered_visible":"WidgetPreview_powered_visible__2ncSu"};